// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-page {
  min-height: 100vh;
  background: #f9fafb;
  padding: 120px 16px 60px;
}

.support-container {
  max-width: 680px;
  margin: 0 auto;
}

.support-header {
  margin-bottom: 32px;
}

.support-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
}

.support-header p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 16px;
}

.back-link {
  font-size: 14px;
  color: #034EA2;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

.support-form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 32px;
}

.type-selector {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.type-btn {
  flex: 1 1;
  padding: 10px;
  border: 1.5px solid #d1d5db;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
}

.type-btn.active {
  border-color: #034EA2;
  background: #e8eef5;
  color: #034EA2;
}

.recipient-note {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 24px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.form-group label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
}

.form-group input,
.form-group textarea {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 14px;
  color: #111827;
  outline: none;
  transition: border-color 0.2s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #034EA2;
}

.form-group textarea {
  resize: vertical;
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background: #034EA2;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.submit-btn:hover {
  background: #1a3d6e;
}

@media (max-width: 600px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .support-form-card {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/support.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".support-page {\n  min-height: 100vh;\n  background: #f9fafb;\n  padding: 120px 16px 60px;\n}\n\n.support-container {\n  max-width: 680px;\n  margin: 0 auto;\n}\n\n.support-header {\n  margin-bottom: 32px;\n}\n\n.support-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #111827;\n  margin-bottom: 8px;\n}\n\n.support-header p {\n  font-size: 16px;\n  color: #6b7280;\n  margin-bottom: 16px;\n}\n\n.back-link {\n  font-size: 14px;\n  color: #034EA2;\n  text-decoration: none;\n}\n\n.back-link:hover {\n  text-decoration: underline;\n}\n\n.support-form-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 32px;\n}\n\n.type-selector {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.type-btn {\n  flex: 1;\n  padding: 10px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 8px;\n  background: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.type-btn.active {\n  border-color: #034EA2;\n  background: #e8eef5;\n  color: #034EA2;\n}\n\n.recipient-note {\n  font-size: 13px;\n  color: #6b7280;\n  margin-bottom: 24px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.form-group input,\n.form-group textarea {\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #111827;\n  outline: none;\n  transition: border-color 0.2s ease;\n  font-family: inherit;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  border-color: #034EA2;\n}\n\n.form-group textarea {\n  resize: vertical;\n}\n\n.submit-btn {\n  width: 100%;\n  padding: 12px;\n  background: #034EA2;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.submit-btn:hover {\n  background: #1a3d6e;\n}\n\n@media (max-width: 600px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .support-form-card {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
